import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export default function LockedFeature({ feature }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-12 text-center shadow-sm flex flex-col items-center gap-4" data-testid="locked-feature">
      <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
        <Lock className="h-6 w-6 text-slate-400" />
      </div>
      <div>
        <h3 className="font-display font-bold text-xl tracking-tight">{feature} is a paid feature</h3>
        <p className="text-slate-500 text-sm mt-1 max-w-md">Subscribe to a plan to unlock {feature.toLowerCase()}. Your gap analysis stays free.</p>
      </div>
      <Link to="/app/billing" data-testid="upgrade-btn"
        className="bg-brand text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-brand-secondary transition-colors">
        View plans
      </Link>
    </div>
  );
}
